import { render, staticRenderFns } from "./BRyOk.vue?vue&type=template&id=1f4873dc&scoped=true&"
import script from "./BRyOk.vue?vue&type=script&lang=js&"
export * from "./BRyOk.vue?vue&type=script&lang=js&"
import style0 from "./BRyOk.vue?vue&type=style&index=0&id=1f4873dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4873dc",
  null
  
)

export default component.exports